import { lazy } from 'react'
import * as Layout from 'layouts'

// Lazy load all page components for better performance
const Home = lazy(() => import('./landingPage/home'))
const BusinessConnect = lazy(() => import('./landingPage/home/businessConnect'))
const RegisterNow = lazy(() => import('./landingPage/registerNow'))
const ListBusiness = lazy(() => import('./landingPage/listBusiness'))
const Jobs = lazy(() => import('./landingPage/jobs'))
const OpeningForm = lazy(() => import('./landingPage/jobs/OpeningForm'))
const Searchlist = lazy(() => import('./landingPage/jobs/Searchlist'))
const Resume = lazy(() => import('./landingPage/jobs/Resume'))
const UpdateOpeningform = lazy(() => import('./landingPage/jobs/UpdateOpeningform'))
const ResumeSearchlist = lazy(() => import('./landingPage/jobs/ResumeSearchlist'))
const Matrimonial = lazy(() => import('./landingPage/matrimonial/Matrimonial'))
const Registration = lazy(() => import('./landingPage/matrimonial/Registration'))
const Userprofile = lazy(() => import('./landingPage/matrimonial/Userprofile'))
const FullProfile = lazy(() => import('./landingPage/matrimonial/FullProfile'))
const Edit = lazy(() => import('./landingPage/matrimonial/Edit'))
const Spirituality = lazy(() => import('./landingPage/spirituality/'))
const Events = lazy(() => import('./landingPage/events'))
const EventDetail = lazy(() => import('./landingPage/events/detail'))
const DonationForm = lazy(() => import('./landingPage/donation'))
const AboutUs = lazy(() => import('./landingPage/aboutUs'))
const ContactUs = lazy(() => import('./landingPage/contactUs'))
const Faq = lazy(() => import('./landingPage/faqs'))
const PrivacyPolicy = lazy(() => import('./landingPage/privacyPolicy'))
const TermsAndConditions = lazy(() => import('./landingPage/termsAndConditions'))
const MobileWeb = lazy(() => import('./landingPage/mobileWeb'))
const Allforms = lazy(() => import('./landingPage/allforms'))
const SellerForm = lazy(() => import('./landingPage/allforms/Seller'))
const BuyerForm = lazy(() => import('./landingPage/allforms/Buyer'))
const RequirementForm = lazy(() => import('./landingPage/allforms/Requirement'))
const ViewAll = lazy(() => import('./landingPage/home/news/viewAll'))
const NewsDetail = lazy(() => import('./landingPage/home/news/NewsDetail'))
const SuccessStories = lazy(() => import('./landingPage/home/successStories/AllStories'))
const SuccessStoryDetail = lazy(() => import('./landingPage/home/successStories/StoryDetail'))
const BlogDetail = lazy(() => import('./landingPage/home/blog/blogDetail'))
const BlogListPage = lazy(() => import('./landingPage/home/blog/bloglistPage'))
const Volunteer = lazy(() => import('./landingPage/volunteer'))
const Referral = lazy(() => import('./landingPage/referral'))

const Search = lazy(() => import('./common/searchResults'))
const BusinessProfile = lazy(() => import('./common/businessProfile'))
const ListingDetail = lazy(() => import('./common/listingDetail'))
const UserProfile = lazy(() => import('./common/userProfile'))
const PlanRenewal = lazy(() => import('./common/planRenewal'))
const SuccessPage = lazy(() => import('./common/successPage'))

const ChangePin = lazy(() => import('./admin/changePin'))
const Login = lazy(() => import('./admin/login'))
const ForgotPin = lazy(() => import('./admin/login/forgotPin'))
const SignUp = lazy(() => import('./admin/signUp'))
const Verify = lazy(() => import('./admin/verify'))
const EditProfile = lazy(() => import('./admin/editProfile'))
const Listings = lazy(() => import('./admin/business/listings'))
const AddOrEditListing = lazy(() => import('./admin/business/listings/addOrEditListing'))
const Business = lazy(() => import('./admin/business'))
const ViewBusinessLeads = lazy(() => import('./admin/business/viewLeads'))
const RegisterBusiness = lazy(() => import('./admin/business/register'))
const SignOut = lazy(() => import('./admin/signOut'))
const Notifications = lazy(() => import('./admin/notifications'))
const SubscriptionMiddle = lazy(() => import('./admin/subscriptionMiddle'))
const Subscription = lazy(() => import('./admin/subscription'))
const ViewLeads = lazy(() => import('./admin/business/listings/viewLeads'))
const MembershipCard = lazy(() => import('./admin/memberShipCard'))
const Meetings = lazy(() => import('./admin/meetings'))
const MeetingRoom = lazy(() => import('./admin/meetings/Room'))
const Chat = lazy(() => import('./admin/chat'))
const ChatCallRoom = lazy(() => import('./admin/chat/CallRoom'))

const landingPage = [
  {
    path: '/home',
    Component: Home,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/success-stories',
    Component: SuccessStories,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/success-stories/detail',
    Component: SuccessStoryDetail,
    Super: Layout.Home,
    auth: false
  },
  {
     path: '/home/businessConnect',
    Component: BusinessConnect,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/registerNow',
    Component: RegisterNow,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/listBusiness',
    Component: ListBusiness,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/spirituality',
    Component: Spirituality,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/events',
    Component: Events,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/events/:eventId',
    Component: EventDetail,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/donation',
    Component: DonationForm,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/jobs',
    Component: Jobs,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/jobs/opening-form',
    Component: OpeningForm,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/jobs/search-list',
    Component: Searchlist,
    Super: Layout.Home,
    auth: false
  },  
  {
    path: '/jobs/resume',
    Component: Resume,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/jobs/update-opening-form/:jobId',
    Component: UpdateOpeningform,
    Super: Layout.Home,
    auth: false
  },
  {
     path: '/jobs/resume-search-list',
     Component: ResumeSearchlist,
     Super: Layout.Home,
     auth: false
  },
  {
    path: '/matrimonial',
    Component: Matrimonial,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/matrimonial/registration-form',
    Component: Registration,
    Super: Layout.Home,
    auth: false,
  },

  {
    path: '/matrimonial/user-profile',
    Component: Userprofile, 
    Super: Layout.Home,
    auth: false,
  },

  {
    path: '/matrimonial/full-profile/:profileId',
    Component: FullProfile,
    Super: Layout.Home,
    auth: false,
  },

  {
    path: '/matrimonial/edit-profile/:profileId',
    Component: Edit,
    Super: Layout.Home,
    auth: false,
  },

  {
    path: '/aboutUs',
    Component: AboutUs,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/contactUs',
    Component: ContactUs,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/faq',
    Component: Faq,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/privacyPolicy',
    Component: PrivacyPolicy,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/terms&conditions',
    Component: TermsAndConditions,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/mobileWeb',
    Component: MobileWeb,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/allforms',
    Component: Allforms,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/seller',
    Component: SellerForm,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/buyer',
    Component: BuyerForm,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/requirement',
    Component: RequirementForm,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/viewAll',
    Component: ViewAll,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/newsDetail/:newsId',
    Component: NewsDetail,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/blogDetail/:blogId',
    Component: BlogDetail,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/blog/viewAll',
    Component: BlogListPage,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/volunteer',
    Component: Volunteer,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/referral',
    Component: Referral,
    Super: Layout.Home,
    auth: false
  }
]

const common = [
  {
    path: '/searchResults',
    Component: Search,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/businessProfile/:businessId',
    Component: BusinessProfile,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/userProfile/:userId',
    Component: UserProfile,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/planRenewal',
    Component: PlanRenewal,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/successPage',
    Component: SuccessPage,
    Super: Layout.Home,
    auth: false
  },
  // Dynamic routes for business profiles
  {
    path: '/:location',
    Component: Search,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/:location/:fkBusinessId',
    Component: BusinessProfile,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/:location/:fkBusinessId/:fkListingId',
    Component: ListingDetail,
    Super: Layout.Home,
    auth: false
  },
  {
    path: '/userProfile/:fkUserId',
    Component: UserProfile,
    Super: Layout.Home,
    auth: false
  }
]

const admin = [
  {
    path: '/userAdmin/editProfile/changePin',
    Component: ChangePin,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/login',
    Component: Login,
    auth: false
  },
  {
    path: '/forgotPin',
    Component: ForgotPin,
    auth: false
  },
  {
    path: '/signUp',
    Component: SignUp,
    auth: false
  },
  {
    path: '/verify',
    Component: Verify,
    Super: Layout.Admin,
    auth: false
  },
  {
    path: '/userAdmin/editProfile',
    Component: EditProfile,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/:businessId/listings',
    Component: Listings,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/:businessId/listings/addListing',
    Component: AddOrEditListing,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/:businessId/listings/editListing/:listingId',
    Component: AddOrEditListing,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/businesses',
    Component: Business,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/viewLeads/:businessId',
    Component: ViewBusinessLeads,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/editBusiness/:partNo/:businessId',
    Component: RegisterBusiness,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/registerBusiness/:partNo',
    Component: RegisterBusiness,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/listings/viewLeads/:listingId',
    Component: ViewLeads,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/signOut',
    Component: SignOut,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/notifications',
    Component: Notifications,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/subscriptionInfo',
    Component: SubscriptionMiddle,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/subscription',
    Component: Subscription,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/memberShipCard',
    Component: MembershipCard,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/meetings',
    Component: Meetings,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/meetings/:meetingId',
    Component: MeetingRoom,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/chat',
    Component: Chat,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/userAdmin/chat/call/:channelId/:callId',
    Component: ChatCallRoom,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/renewPlan',
    Component: PlanRenewal,
    auth: false
  },
  {
    path: '/paymentSuccess/:paymentDetails',
    Component: SuccessPage,
    auth: false
  }
]

const routes = [...landingPage, ...common, ...admin]

export default routes

